import { render } from "./RiPermission.vue?vue&type=template&id=41a035dc"
import script from "./RiPermission.vue?vue&type=script&lang=js"
export * from "./RiPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41a035dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41a035dc', __exports__)) {
    api.reload('41a035dc', __exports__)
  }
  
  module.hot.accept("./RiPermission.vue?vue&type=template&id=41a035dc", () => {
    api.rerender('41a035dc', render)
  })

}


export default __exports__